export const version = '2.23.2';
//# sourceMappingURL=version.js.map